<template>
  <div class="outer" :class="{ justUpdated: hasUnwatchedAlarms, compact: user.uiSettings.compact, 'run-test': user.features.runTest}">
    <!-- Name, room, battery, location, ecg image, stop and play buttons -->
      <div v-if="user.uiSettings.compact">
        <div class="header-wrapper" >
          <div><strong>{{ patient.name }}</strong>
            <span v-if="patient.risk">(<font-awesome-icon icon="exclamation-circle" />: {{patient.risk}})</span>
          </div>
          <div><span v-if="patient.room">{{$t('Room')}}: {{patient.room}}</span></div>

            <div style="text-align: end;">
              <span v-if="user.features.onlineStatus" class="dot" :class="{'dot--green': device && device.is_online === 1}"></span>
              <font-awesome-icon style="vertical-align: -0.2rem;" icon="battery-half" />:<div class="battery--value">{{lastBattery}}%</div>
            </div>
            <div v-if="user.features.runTest && isAllowedType('ecg')" style="text-align: end;">
              <div v-if="ecgTestActive" @click="showEcgTestModal()" style="cursor: pointer; height: 22px; width: 3rem; overflow: hidden;">
                <img src="../assets/images/ecg_process.gif" height="54px" width="250px" alt="Icon">
              </div>
            </div>
            <div v-if="user.features.runTest" style="text-align: end; margin-top: -4px; height: 1rem">
              <span v-if="!isTestActive" class="tooltip" @click="showModal({componentName: 'StartMedicalTest', modalTitle: $t('medical-test'), modalData: {patient: patient}})"><span class="tooltiptext">{{ $t('Start a Test') }}</span><font-awesome-icon class="iconP" icon="play-circle" /></span>
              <span v-if="isTestActive" class="tooltip" @click="stopTest()"><span class="tooltiptext">{{$t('Stop a Test')}}</span><font-awesome-icon class="iconR" icon="stop-circle"  /></span>
            </div>
        </div>
      </div>
      <div v-else class="patient">
      <div class="stay">  <p class="pn"> {{$t('patient-name')}}: {{ patient.name }} ({{$t('risk-status')}}: {{patient.risk}}&nbsp;<font-awesome-icon icon="exclamation-circle" />)
      </p>
        <div class="abs">
          <div class="r">{{$t('Room')}}: {{patient.room}}</div>
        </div>
        <div class="abs">
          <div class="b"><font-awesome-icon icon="battery-half" />&nbsp;{{$t('Battery')}}: {{lastBattery}}%</div>
          <div class="b"><font-awesome-icon icon="map-marker-alt" />&nbsp;{{lastAddress}}</div>
        </div>
      </div>
      <div v-if="user.features.runTest" class="play">
        <span v-if="!isTestActive" class="tooltip" @click="showModal({componentName: 'StartMedicalTest', modalTitle: $t('medical-test'), modalData: {patient: patient}})"><span class="tooltiptext">{{ $t('Start a Test') }}</span><font-awesome-icon class="iconP" icon="play-circle" /></span>
        <span v-if="isTestActive" class="tooltip" @click="stopTest()"><span class="tooltiptext">{{$t('Stop a Test')}}</span><font-awesome-icon class="iconR" icon="stop-circle"  /></span>
      </div>
      <div v-if="isAllowedType('ecg')">
        <svg v-if="!ecgTestActive" class="ecg" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             viewBox="-466.4 259.6 280.2 47.3" enable-background="new -466.4 259.6 280.2 47.3" xml:space="preserve">
        <polyline fill="none" stroke="white" class="ekg" stroke-width="2" stroke-linecap="square" stroke-miterlimit="10" points="-465.4,281
        -436,281 -435.3,280.6 -431.5,275.2 -426.9,281 -418.9,281 -423.9,281 -363.2,281 -355.2,269 -345.2,303 -335.2,263 -325.2,291
        -319.2,281 -187.2,281 "/>
        </svg>
        <div v-if="ecgTestActive" @click="showEcgTestModal()" style="position: absolute; right: -17px; top: 27px; cursor: pointer;">
          <img src="../assets/images/ecg_process.gif" height="54px" width="250px" alt="Icon">
        </div>
      </div>
    </div>
    <!-- the small boxes that have the icons, ***this is where the data should display*** -->
    <!-- clicking on the box opens a modal below that display the tabs page, Charts.vue -->
    <!-- Defaults to History/Graph page when click to open -->
    <div class="body-wrapper" :class="{'small-icons': $store.state.availableDataTypes.length > 5}">
      <div v-if="isAllowedType('hr')" class="box k" @click.stop="showHistory('hr')" style="font-weight: bold" v-bind:style="getHealthLevelStyle('hr')">
        <font-awesome-icon icon="heartbeat" />&nbsp;
        {{medicalData('hr')}}
      </div>

      <div v-if="isAllowedType('resp')" class="box f" @click.stop="showHistory('resp')" style="font-weight: bold">
        <font-awesome-icon icon="lungs" />&nbsp
        {{medicalData('resp')}}
      </div>

      <div v-if="isAllowedType('blood_pressure')" class="box g" id="box3" style="font-weight: bold" @click.stop="showHistory('bp_sys')" :style="{'font-size': isSmallIndicatorBox ? '0.9vw' : ''}">
        <img src="../assets/images/blood-pressure-gauge.svg" :style="{width: isSmallIndicatorBox ? '0.8em' : '1.1em'}">
<!--        <font-awesome-icon icon="stethoscope" />&nbsp;-->
        {{medicalData('blood_pressure')}}
      </div>

      <div v-if="isAllowedType('pose')" class="box k" id="box4" @click.stop="showHistory('pose')">
        <font-awesome-icon icon="male" />&nbsp;
        {{medicalData('pose')}}
      </div>

      <div v-if="isAllowedType('spo2')" class="box k"  id="box6" style="font-weight: bold" @click.stop="showHistory('spo2')" v-bind:style="getHealthLevelStyle('spo2')">
        <span style="font-weight: bold">O</span><sub style="font-weight: bold">2</sub>&nbsp;
        {{medicalData('spo2')}}
      </div>

      <div v-if="isAllowedType('temp')" class="box e"  id="box7" style="font-weight: bold" @click.stop="showHistory('temp')">
        <font-awesome-icon icon="thermometer-half" />&nbsp;
        {{medicalData('temp')}}
      </div>

      <div v-if="isAllowedType('glucose')" class="box h"  id="box8"  @click.stop="showHistory('glucose')">
        <font-awesome-icon icon="tint" />&nbsp;
        {{medicalData('glucose')}}
      </div>

      <div v-if="isAllowedType('steps')" class="box i" id="box9" @click.stop="showHistory('steps')">
        <font-awesome-icon icon="shoe-prints" />&nbsp
        {{medicalData('steps')}}
      </div>

      <div v-if="isAllowedType('avg_rri')" class="box avg_rri" style="font-weight: bold" @click.stop="showHistory('avg_rri')">
        <img src="../assets/images/heart-monitor.svg" style="width: 1.1em">
        {{medicalData('avg_rri')}}
      </div>

      <div v-if="isAllowedType('rmssd')" class="box rmssd" style="font-weight: bold" @click.stop="showHistory('rmssd')">
        <img src="../assets/images/heart-monitor.svg" style="width: 1.1em">
        {{medicalData('rmssd')}}
      </div>

      <div v-if="isAllowedType('ecg')" class="box c" id="box10" @click.stop="showHistory('ecg')">
        <font-awesome-icon icon="file-medical-alt" />&nbsp;
      </div>

      <div class="box d" :class="'background-' + medicalData('unwatchedAlarmsLevel')"  id="box5" @click.stop="showAlarms()" >
        <font-awesome-icon icon="bell" />&nbsp;
        {{medicalData('unwatchedAlarmsCnt')}}
      </div>

    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations, mapState} from "vuex";
import Vue from "vue";
import axios from "axios";
import utils from "../plugins/utils";

export default {
  name: "PatientBlock",
  props: ['patient'],
  computed: {
    ...mapGetters({isAllowedType: 'isAvailableDataType'}),
    ...mapState(['user']),
    isSmallIndicatorBox() {
      return this.$store.state.availableDataTypes.length > 5
    },
    medicalData() {
      return (type) => {
        let data = '-';
        if (this.patient.medicalData && (this.patient.medicalData[type] || type === 'blood_pressure')) {
          if (type === 'pose') {
            data = this.$t(utils.preparePoseName(this.patient.medicalData[type].data));
          }
          else if (type === 'blood_pressure') {
            if (this.patient.medicalData['bp_sys']) {
              data = this.patient.medicalData['bp_sys'].data + '/' + this.patient.medicalData['bp_dia'].data;
            }
          }
          else {
            data = this.patient.medicalData[type].data || this.patient.medicalData[type];

            if (type === 'temp') {
              data = utils.prepareTempValue(data);
            }
            else if (type === 'glucose') {
              data = utils.prepareSugarValue(data);
            }
          }
        }
        return data;
      }
    },
    device() {
      return this.$store.getters.getDeviceById(this.patient.devices_ids[0]);
    },
    lastAddress() {
      return this.device ? this.device.last_address : '';
    },
    lastBattery() {
      return this.device ? this.device.last_battery : '';
    },
    ecgTestActive() {
      return this.patient.lastTest && this.patient.lastTest.id && !this.patient.lastTest.ended && (this.patient.lastTest.type === 'ecg_smct' || this.patient.lastTest.type === 'patch_vital')
        && this.patient.medicalData && this.patient.medicalData.ecg;
    },
    isTestActive() {
      return this.patient.lastTest && this.patient.lastTest.id && !this.patient.lastTest.ended;
    },
    hasUnwatchedAlarms() {
      return this.patient.medicalData && parseInt(this.patient.medicalData.unwatchedAlarmsCnt) > 0;
    },
    getHealthLevelStyle() {
        return (type) => {
            const adv = this.medicalData('advanced');
            if (adv && adv[type] && adv[type].healthLevel)
                return {padding: '5px', border: '5px solid ' + adv[type].healthLevel.recommendedColor}
            else
                return undefined
        }
    },
  },
  methods: {
    async stopTest() {
      try {
        const res = await axios.post('/api/medical/finishTest/' + this.patient.devices_ids[0]).then(res => res.data);
        if (res.data) {
          this.$notify({text: this.$t('Medical test stopped'), type: 'success'});
        }
        else {
          this.$notify({text: this.$t('There is no active medical tests for this patient'), type: 'warn'});
        }
      } catch (err) {
        this.$notify({text: this.$t('Something go wrong('), type: 'error'});
        console.log(err);
      }
    },
    showHistory(type) {
      this.$store.commit('setSelectedPatient', this.patient);
      this.$store.commit('setSelectedMedicalDataType', type);
      this.showModal({componentName: 'PatientInfo', modalTitle: this.$t('patient-settings'), modalData: {activeTab: 3}})
    },
    showEcgTestModal() {
      this.$store.commit('setSelectedPatient', this.patient);
      this.showModal({componentName: 'EcgChart', modalTitle: this.$t('Realtime ECG chart')});
    },
    showAlarms() {
      this.$store.commit('setSelectedPatient', this.patient);
      this.showModal({componentName: 'PatientInfo', modalTitle: this.$t('patient-settings'), modalData: {activeTab: 1}})
    },
    ...mapMutations(['showModal']),
  },
  watch: {
    patient(newVal, oldVal) { // watch it
      console.log('patient changed: ', newVal, ' | was: ', oldVal)
      this.patient = newVal;
    }
  },
}
</script>

<style scoped>

.background-red {
  background-color: red;
}
.background-orange {
  background-color: orange;
}

.dot {
  height: 10px;
  width: 10px;
  background-color: red;
  border-radius: 50%;
  display: inline-block;
}

.dot--green {
  background-color: mediumseagreen;
}

.battery--value {
  display: inline-block;
  text-align: end;
  min-width: 4ch;
}

</style>



// WEBPACK FOOTER //
// src/components/PatientBlock.vue